import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ContractProfileTemplateState } from "./model";

let state: ContractProfileTemplateState = {
  contractProfileTemplates: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ContractProfileTemplateState, RootStateType>;
